import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "Namespace Alternatives",
description: "Learn how to replace hierarchical visibility in Freon using namespace alternatives, including qualified-name scenarios, recursive alternatives, and how alternatives transform the namespace tree into a graph.",
tags: [ "namespace alternatives", "scoping", "visibility", "qualified names", "recursive alternatives", "namespace graph", "scope rules", "Freon", "DSL development"] ,
modifiedTime: "2025-11-07T17:39:02.389Z",
publishedTime: "2025-11-07T17:20:18.623Z"
    }
  };
};